import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const uzbprimeeldConfig: TSPConfig = {
  key: 'uzbprimeeld',
  name: 'UzbPrimeELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request a Company API Key from UzbPrimeELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter Company API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default uzbprimeeldConfig;
